<div mat-dialog-title>
  <div class="d-flex justify-content-between">
      <p>Create New - Change Control Note</p>
      <i id="ibtClose" class="fa fa-times-circle pull-right" (click)="closeDialog()" aria-hidden="true"></i>
  </div>
</div>
<div mat-dialog-content class="">
  <div class="row com-doc-head eip-mt-20">
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 eip-pl-10">
          <mat-button-toggle-group aria-label="CCN Type" class="com-semiauto" [value]='ccnType' (change)="onValChange($event.value)">
              <mat-button-toggle *ngFor="let type of ccnTypeList;" value="{{type.deD_Id}}">{{type.deD_Description}}
              </mat-button-toggle>
          </mat-button-toggle-group>
      </div>
  </div>
  <mat-accordion>
      <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header [expandedHeight]="'50px'" [collapsedHeight]="'50px'">
              <mat-panel-title id="accAccountCodeMaster">
                  <div class="d-flex justify-content-between eip-pt-10 eip-pb-10">
                      <div class="title-container d-flex align-items-center">
                          <mat-label>Change Control Note</mat-label>
                          <mat-label class="eip-ml-10" *ngIf="ccnNo!=''"> - {{ccnNo}}</mat-label>
                      </div>
                      <div class="acc-icon-container align-items-center d-flex eip-mr-0" *ngIf="ccnId!=-1">
                          <i title="Attachment" class="fa fa-paperclip fs-20" aria-hidden="true" id="ibtINDVCollapseAll" (click)="$event.stopPropagation(); attachmentClick()"></i>
                      </div>
                  </div>
              </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row eip-mt-20">
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                  <div class="view-info eip-mb-20">
                      <p class="view-label">Project Code / Name</p>
                      <p class="view-data" id="lblisConfidential">
                          {{project}}
                      </p>
                  </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                  <div class="view-info eip-mb-20">
                      <p class="view-label">Initiated By</p>
                      <p class="view-data">{{initiatedBy}}
                      </p>
                  </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                  <div class="view-info eip-mb-20">
                      <p class="view-label">Discipline</p>
                      <p class="view-data" id="lblwarehouse">
                          {{discipline}}
                      </p>
                  </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                  <div class="view-info eip-mb-20">
                      <p class="view-label">Approvers</p>
                      <p class="view-data"> {{approvers}}
                      </p>
                  </div>
              </div>
          </div>
          <form [formGroup]="ccnInputForm">
              <div class="eip-mt-20 eip-mb-10">
                  <div class="row">
                      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                          <mat-form-field>
                              <mat-label>Title for Change Control</mat-label><input matInput formControlName="txtTitle" required>
                              <mat-error *ngIf="ccnInputForm.get('txtTitle').hasError('required')">
                                  Title is required
                              </mat-error>
                          </mat-form-field>
                      </div>
                      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                          <mat-form-field>
                              <mat-label>Description Reason for Change</mat-label>
                              <input matInput formControlName="txtReason" required>
                              <mat-error *ngIf="ccnInputForm.get('txtReason').hasError('required')">
                                  Reason is required
                              </mat-error>
                          </mat-form-field>
                      </div>
                      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                          <mat-form-field>
                              <mat-label>Reference Drawing / Documents</mat-label>
                              <input matInput formControlName="txtRef" required>
                              <mat-error *ngIf="ccnInputForm.get('txtRef').hasError('required')">
                                  Reference is required
                              </mat-error>
                          </mat-form-field>
                      </div>
                      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                          <mat-form-field>
                              <mat-label>Action</mat-label><input matInput formControlName="txtAction" required>
                              <mat-error *ngIf="ccnInputForm.get('txtAction').hasError('required')">
                                  Action is required
                              </mat-error>
                          </mat-form-field>
                      </div>
                  </div>
              </div>
          </form>
          <div class="row">
              <div class="eip-pr-20 eip-ml-auto eip-mt-10" *ngIf="ccnId==-1">
                  <input type="submit" value="Save & Generate Number" class="btn btn-primary eip-ml-20" id="btnGenerate" (click)="generateCCN()">
              </div>
              <div class="eip-pr-20 eip-ml-auto eip-mt-10" *ngIf="ccnId!=-1">
                  <input type="submit" value="Print Document" class="btn btn-secondary" *ngIf="canPrint" id="BtnClear" (click)="printCCN()">
                  <input type="submit" value="Submit" class="btn btn-primary eip-ml-20" *ngIf="canSubmit" id="btnSearch" (click)="submitCCN()">
              </div>
          </div>
          <div class="eip-mt-20" [ngClass]="{'kgrid-fullscreen' : enableFullscreen }" *ngIf="ccnId!=-1 && (this.inputCCN.status=='Pending for manhour' || this.inputCCN.status=='Pending for publish')">
              <kendo-grid #MHGrid [kendoGridBinding]="MHList" [reorderable]="true" [sortable]="true" [resizable]="true" [filterable]="false" [pageable]="false" (edit)="EditRowData($event)" (save)="UpdateRowData($event)" (cancel)="cancelRowData($event)">
                  <kendo-grid-column title="Sl.No." filterable="false" [width]="60">
                      <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                          {{rowIndex+1}}
                      </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column title="Discipline" field="discDescription" [width]="100">
                      <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                          <span class="no-wrap" eipTooltip="{{dataItem.discDescription}}" eipTooltipPosition="auto">{{dataItem.discDescription}}</span>
                      </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column title="Name" field="memberId" [width]="150">
                      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                          <span class="no-wrap" eipTooltip="{{dataItem.memberName}}" eipTooltipPosition="auto">{{dataItem.memberName}}</span>
                      </ng-template>
                      <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                          <EIPAutoComplete [IsDisabled]="!dataItem.Enable" ShowTextValueField='N' setId="discMember{{rowIndex}}" floatLabelOption="never" TextField="memberName"  ValueField="memberId" WaterMarkText="Member" [IsCascading]='true' [dataSource]='dataItem.discMembers' ShowTextValueField='N' [defaultValue]="dataItem.memberId" (valueChange)="memberChange($event,dataItem)">
                          </EIPAutoComplete>
                         
                      </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column title="Status" field="cCNStatus" [width]="80">
                      <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                          <span class="no-wrap" eipTooltip="{{dataItem.cCNStatusDesc}}" eipTooltipPosition="auto">{{dataItem.cCNStatusDesc}}</span>
                      </ng-template>
                      <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                          <EIPAutoComplete [IsDisabled]="!dataItem.Enable" ShowTextValueField='N' setId="category{{rowIndex}}" floatLabelOption="never" TextField="description"  ValueField="value" WaterMarkText="Status" [IsCascading]='true' [dataSource]='MHStatusList' ShowTextValueField='N' [defaultValue]="dataItem.cCNStatus" (valueChange)="statusChange($event,dataItem)">
                          </EIPAutoComplete>
                      </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column title="Man Hours" field="manHour" [width]="80">
                      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                          <span class="no-wrap" eipTooltip="{{dataItem.manHour}}" eipTooltipPosition="auto">{{dataItem.manHour}}</span>
                      </ng-template>
                      <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                          <div class="fs-12 ff-2 eip-pr-10">
                              <input [disabled]="dataItem.Enable"  matInput class="border-bottom"  [(ngModel)]="dataItem.manHour" required type="number">
                         
                            </div>
                      </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column title="No of Drawings" field="noOfDoc" [width]="80">
                      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                          <span class="no-wrap" eipTooltip="{{dataItem.noOfDoc}}" eipTooltipPosition="auto">{{dataItem.noOfDoc}}</span>
                      </ng-template>
                      <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                          <div class="fs-12 ff-2 eip-pr-10">
                              <input [disabled]="dataItem.Enable" matInput class="border-bottom"  [(ngModel)]="dataItem.noOfDoc" required type="number">
                          </div>
                      </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column title="Remarks" field="cCNRemarks" [width]="150">
                      <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                          <span class="no-wrap" eipTooltip="{{dataItem.cCNRemarks}}" eipTooltipPosition="auto">{{dataItem.cCNRemarks}}</span>
                      </ng-template>
                      <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                          <div class="fs-12 ff-2 eip-pr-10">
                              <input matInput class="border-bottom"  [(ngModel)]="dataItem.cCNRemarks" required>
                          </div>
                      </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column title="Not Applicable" field="notApplicable" [width]="100">
                      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                          <div class="fs-12 ff-2 eip-pr-10">
                              <mat-slide-toggle color="primary" class="eip-ml-10" [(ngModel)]="dataItem.notApplicable" (change)="notApplicableChange($event)">
                              </mat-slide-toggle>
                          </div>
                      </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column title="Actions" [width]="100">
                      <ng-template kendoGridCellTemplate let-rowIndex="rowIndex" let-dataItem="dataItem">
                          <div>
                              <button kendoGridEditCommand class="k-grid-add-command">
                                  <i *ngIf="this.memberId==this.ccn.createdBy||dataItem.memberId ==this.memberId" class="fa fa-pencil icon-size mr-2" matTooltip="Edit" style="font-size: 20px;" id="" aria-hidden="true"></i>
                              </button>
                              <button kendoGridSaveCommand type="button" class="k-grid-add-command">
                                  <i class="fa fa-save icon-size mr-2" matTooltip="Save" style="font-size: 20px;" id="" aria-hidden="true"></i>
                              </button>
                              <button kendoGridCancelCommand type="button" class="k-grid-add-command">
                                  <i class="fa fa-times-circle icon-size mr-2" matTooltip="Cancel" style="font-size: 20px;" id="" aria-hidden="true"></i>
                              </button>
                          </div>
                      </ng-template>
                  </kendo-grid-column>
              </kendo-grid>
          </div>
      </mat-expansion-panel>
  </mat-accordion>
</div>
<div mat-dialog-actions>
  <div class="row justify-content-end flex-grow-1">
     <button class="btn btn-primary" id="btnSave" [disabled]="this.canSave" *ngIf="ccnId!=-1 && (this.inputCCN.status=='Pending for manhour' || this.inputCCN.status=='Pending for publish')" (click)="saveCCN()"><i class="fa fa-save" aria-hidden="true" id="btnCopy"></i>&nbsp;&nbsp;Save</button>
  </div>
</div>